import { abortableFetch, useEventCallback } from '@eas/common-web';
import { createParticipantRequestTarget } from '@composite/participants/participant-create-utils';
import { EsFile, Proposer } from '@models';
import { EvidenceApiUrl, ParticipantType } from '@enums';

export function useAddProposerDialog() {
  const callApi = useEventCallback(
    (formData: Proposer, esFile: EsFile | undefined) => {
      const requestTarget = createParticipantRequestTarget(
        esFile,
        EvidenceApiUrl.ES_FILES
      );

      return abortableFetch(requestTarget.url, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          ...formData,
          type: ParticipantType.PROPOSER,
          esFile: requestTarget.esFile,
        }),
      });
    }
  );

  return {
    callApi,
  };
}
